import { observable, action } from "mobx";

export default class AccountVerificationStore {
	@observable isActive: boolean = false;
	@observable message: string | null = "";
	@observable url: string = "";
	@observable buttonText: string = "";
	@observable shouldShowCloseButton: boolean = true;

	@observable partialDepositAmount: number | null = null;
	@observable partialDepositFunction: Function | null = null;

	@action.bound
	closePopup() {
		this.isActive = false;
		this.message = "";
		this.url = "";
		this.buttonText = "";
		this.shouldShowCloseButton = true;
	}

	@action.bound
	showPopup(
		url = "account-settings/account-verification",
		buttonText: string = "ACCOUNT_VERIFICATION.TITLE",
		errorMessage?: string,
		shouldShowCloseButton: boolean = true
	) {
		if (errorMessage) {
			this.message = errorMessage;
		}
		this.shouldShowCloseButton = shouldShowCloseButton;
		this.url = url;
		this.buttonText = buttonText;
		this.isActive = true;
	}

	@action.bound
	setPartialDepositAmount(partialDepositAmount: number | null) {
		this.partialDepositAmount = partialDepositAmount;
	}

	@action.bound
	setPartialDepositFunction(partialDepositFunction: Function | null) {
    	this.partialDepositFunction = partialDepositFunction;
	}

	@action.bound
	onDispose(){
		this.setPartialDepositAmount(null);
		this.setPartialDepositFunction(null);
	}
}
